// extracted by mini-css-extract-plugin
export default {"ButtonControl":"MultiControl_ButtonControl__vanCT"};